































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Injectable, Container } from 'ca-middleware';
@Component({
    name: 'SwitchMap',
})
export default class SwitchMap extends Vue {
    @Injectable() public container!: Container;
    @Prop() public datas: any;
    @Prop() public title: any;
    @Prop() public mapItemClick: any;

    private defaultDatas: any;
    private isShowMapPanel: any = false;
    private myItemIndex: any = 0;
    private myEleIndex: any = 0;
    constructor() {
        super();
    }

    @Watch('datas')
    public setDefaultData() {
        this.defaultDatas = (this.datas && this.datas.length > 0) ? this.datas[this.myItemIndex].layers[this.myEleIndex] : {icon: '', title: ''};
    }


    private defaultClick() {
        this.isShowMapPanel = !this.isShowMapPanel;
    }
    private mapItemBaseClick(ele: any, itemIndex: any, eleIndex: any ) {
        this.defaultDatas = ele;
        this.myItemIndex = itemIndex;
        this.myEleIndex = eleIndex;
        this.isShowMapPanel = false;
        this.mapItemClick(ele);
    }
    private closeClick() {
        this.isShowMapPanel = false;
    }
    private initMapEvents() {
        // 二三维切换，全局通知
        const notify = this.container.resolve('notify');
        notify.on('toSwitch3DEmit', (d: any) => {
              if (d === '3d') {
                  // 前端写死直接切换到三维影像
                  let temp: any = null;
                  let tempItemIndex: any = '';
                  let tempEleIndex: any = '';
                  if (this.datas.length > 0 ) {
                      this.datas.forEach((eleF: any, itemIndex: any) => {
                          if (eleF.layers.length > 0) {
                              eleF.layers.forEach((eleS: any, eleIndex: any) => {
                                  if (eleS.title === '三维影像') {
                                      temp = eleS;
                                      tempItemIndex = itemIndex;
                                      tempEleIndex = eleIndex;
                                  }
                              });
                          }

                      });
                  }
                  this.mapItemBaseClick(temp, tempItemIndex, tempEleIndex);
              }


            }, this,
        );
    }

    private  created() {
        this.defaultDatas = (this.datas && this.datas.length > 0) ? this.datas[this.myItemIndex].layers[this.myEleIndex] : {icon: '', title: ''};

        this.initMapEvents();
    }

}
